import { createPortal } from 'react-dom';
import ProfileMenuPanel from './ProfileMenuPanel';
import { CloseButton, MobileOverlay, MobilePanel } from '../ProfileMenu.styles';

const ProfileMenuMobileOverlay = ({
	open,
	onClose,
	closeLabel,
	accountLabel,
	panelProps,
}) => {
	if (!open) {
		return null;
	}

	return createPortal(
		<MobileOverlay role="presentation" onClick={onClose}>
			<MobilePanel
				role="dialog"
				aria-modal="true"
				aria-label={accountLabel}
				onClick={(event) => event.stopPropagation()}
			>
				<CloseButton type="button" onClick={onClose} aria-label={closeLabel}>
					×
				</CloseButton>
				<ProfileMenuPanel {...panelProps} />
			</MobilePanel>
		</MobileOverlay>,
		document.body,
	);
};

export default ProfileMenuMobileOverlay;
